import { ResponsiveVthOptions, VthVariants } from "../../interface";

const HORIZONAL_ONE_COLUMN: ResponsiveVthOptions = {
    mobile: VthVariants.VERTICAL,
    tablet: VthVariants.HORIZONTAL,
    desktop: VthVariants.HORIZONTAL,
};

const HORIZONAL_TWO_COLUMN: ResponsiveVthOptions = {
    mobile: VthVariants.HORIZONTAL,
    tablet: VthVariants.HORIZONTAL,
    desktop: VthVariants.HORIZONTAL,
};

const MIXED_LAYOUT_PRIMARY_CARD: ResponsiveVthOptions = {
    mobile: VthVariants.VERTICAL,
    tablet: VthVariants.VERTICAL,
    desktop: VthVariants.TALL_VERTICAL,
};

const MIXED_LAYOUT_SECONDARY_CARD: ResponsiveVthOptions = {
    mobile: VthVariants.VERTICAL,
    tablet: VthVariants.HORIZONTAL,
    desktop: VthVariants.VERTICAL,
};

export const VTH_CARD_LAYOUTS = {
    MIXED_LAYOUT_PRIMARY_CARD,
    MIXED_LAYOUT_SECONDARY_CARD,
    HORIZONAL_ONE_COLUMN,
    HORIZONAL_TWO_COLUMN,
};

export const LIVE_FLAG_LABEL = "live";
